import React, { useState } from "react";
import Register from "./Register";
import validator from "validator";
import { Alert } from '@mui/material';
import {useDispatch, useSelector} from "react-redux"
import {useNavigate} from "react-router-dom"
import { setLogin, setMode } from "../redux/appSlice";
import { DarkMode, LightMode } from "@mui/icons-material";

const LoginPage = () => {
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const [resError,setResError]=useState({status:false,msg:""})
  const initialLoginValue={
    email:"",
    password:""
  }
  const [loginValues,setLoginValues]=useState(initialLoginValue)
  const [isLoading,setIsLoading]=useState(false)
  const {mode}=useSelector((state)=>state.app)
  const [validateError,setValidateError]=useState({
  errorStatus:false,
  errorMsg:"",
  })
  

  const handleChange=(e)=>{
    const {name,value}=e.target
    setLoginValues((prevValues)=>({...prevValues,[name]:value}))
  }
  const handleSubmit=async(e)=>{
    e.preventDefault()
    const {email,password}=loginValues
    if(email && password && validator.isEmail(email)){
      setIsLoading(true)
      const loginResponse=await fetch("https://thoughtful-erin-oyster.cyclic.app/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(loginValues),
     })
     const loggedIn=await loginResponse.json()
     if(!loggedIn.msg){
     setIsLoading(false)
      dispatch(setLogin({
        user:loggedIn.user,
        token:loggedIn.token
      }))
      navigate("/home")
     }
     if(loggedIn.msg){
      setResError({status:true,msg:loggedIn.msg})
     }
     setLoginValues(initialLoginValue)
     setValidateError({errorStatus:false,errorMsg:true})
     setIsLoading(false)
    }
    else{
      setValidateError({errorStatus:true,errorMsg:"All fields are required or either you entered an invalid email"})
    }
  }
  const [pageType,setPageType]=useState("login")
  return (
    <div className="flex flex-col gap-10 items-center w-full dark:h-[100vh] dark:bg-[#3D3B3B] ">
      <div className="w-full flex justify-center items-center bg-white dark:bg-gray-900 p-4">
        <h1 className="w-full text-center text-2xl font-bold text-rose-700">SocioConnect</h1>
        {!mode?(<LightMode className="icons-style cursor-pointer dark:text-gray-600 text-gray-600" onClick={()=>dispatch(setMode())}/>):
                    (<DarkMode className="icons-style cursor-pointer dark:text-gray-600 text-gray-600" onClick={()=>dispatch(setMode())}/>)}
      </div>
      <div className="w-[270px] sm:w-[450px] flex flex-col justify-center items-center">
        {pageType==="login"?(
          <form onSubmit={handleSubmit} className="w-full grid grid-cols-4 bg-white dark:bg-gray-900 p-4 rounded-lg gap-4">
          <h1 className="col-span-full w-full text-xs sm:text-sm font-semibold dark:text-gray-100">Welcome to SocioConnect, Build your Connect</h1>
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] col-span-full w-full rounded-md p-2  text-xs border-gray-400 border-2 dark:text-gray-400" type="email" name="email" placeholder="Email" />
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] col-span-full w-full rounded-md p-2  text-xs border-gray-400 border-2 dark:text-gray-400" type="password" name="password" placeholder="Password" />
          <input className=" cursor-pointer col-span-full w-full bg-rose-700 rounded-md p-2 text-sm text-white" type="submit" value={isLoading?("Login...."):("Login")} />
          <h3  className=" col-span-full cursor-pointer text-xs underline decoration-solid text-rose-700"
          onClick={()=>setPageType("register")}>Dont't have an Account? Sign up here</h3>
          {validateError.errorStatus && (<Alert sx={{gridColumn:"1/-1",fontSize:"10px", marginTop:"5px"}} severity="error">{validateError.errorMsg}</Alert>)}
        </form>
        ):(<Register setPageType={setPageType}/>)}
      </div>
      {pageType==="login" && resError.status  ? (<div className="-mt-5">
                        <Alert severity='error' sx={{fontSize:"12px"}}>{resError.msg}</Alert>
                   </div>):null
          }
    </div>
  );
};

export default LoginPage;
